import { useCallback } from 'react'
import cn from 'classnames'
import { useChannelHuddle, useHuddle } from '../../contexts/HuddleContext'
import Icon from '../Common/Icon'
import IconButton from '../Common/IconButton'
import styles from './Huddle.module.scss'

interface IProps {
  channelId: string
  isDisabled: boolean
  className?: string
}

/**
 * Start a huddle in this conversation, join the one going, or leave yours. Shows how
 * many are in it, so a live huddle is visible from the header.
 */
const HuddleHeaderButton = ({ channelId, isDisabled, className }: IProps) => {
  const live = useChannelHuddle(channelId)
  const { snapshot, start, join, leave } = useHuddle()
  const isInThisHuddle = snapshot?.channelId === channelId
  const count = live?.peers.length ?? 0

  const handleClick = useCallback(() => {
    if (isInThisHuddle) leave()
    else if (live) join(channelId, live.id)
    else start(channelId)
  }, [channelId, isInThisHuddle, join, leave, live, start])

  const title = isInThisHuddle
    ? 'Leave huddle'
    : live
      ? `Join huddle (${count} in it)`
      : 'Start a huddle'
  return (
    <IconButton
      title={title}
      box="sm"
      className={cn(className, { [styles.headerLive]: !!live })}
      onClick={handleClick}
      disabled={isDisabled && !isInThisHuddle}
      aria-pressed={isInThisHuddle}
      data-cy="huddle-header-button"
    >
      <Icon name="headphones" size="sm" />
      {live && !isInThisHuddle && <span className={styles.headerCount}>{count}</span>}
    </IconButton>
  )
}

export default HuddleHeaderButton
